// app.component.ts
import { Component } from '@angular/core';

// import { AuthenticationService } from './authentication/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {

	public notificationsOptions = {
	    position: ["bottom", "right"],
	    timeOut: 5000,
	    lastOnBottom: true
	}

    constructor() {}

}


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/app.component.ts